<div [formGroup]="form">
  <div class="label">Telefonnummer</div>
  <mat-radio-group formControlName="phoneNumberOption">
    <app-radio-button-list>
      <app-radio-button-list-item [control]="form.get('phoneNumberOption')" [value]="PhoneNumberOption.NewPhoneNumber">
        <div class="option-title">Nytt eller portere inn</div>
      </app-radio-button-list-item>
      <app-radio-button-list-item
        [control]="form.get('phoneNumberOption')"
        [disabled]="voiceProductsAvailableForUpgrade.length === 0"
        [matTooltip]="voiceProductsAvailableForUpgrade.length === 0 ? 'Ingen ledige/tilgjengelige nummer' : ''"
        [value]="PhoneNumberOption.KeepExisting"
      >
        <div class="option-title">Behold eksisterende ice-nummer</div>
        @if (form.get('phoneNumberOption').value === PhoneNumberOption.KeepExisting) {
          <mat-radio-group class="option-group" formControlName="subscriptionIdToUpgrade">
            @for (voiceProduct of voiceProductsAvailableForUpgrade; track voiceProduct.id) {
              <app-hardware-voice-product-upgrade
                [newOfferingId]="selectedSubscription?.subscriptionOfferingId"
                [subscriptionToUpgrade]="form.get('subscriptionIdToUpgrade').value"
                [voiceProduct]="voiceProduct"
              />
            }
          </mat-radio-group>
        }
      </app-radio-button-list-item>
    </app-radio-button-list>
  </mat-radio-group>
</div>
